import { render, staticRenderFns } from "./SearchContent.vue?vue&type=template&id=7b6b16a4&scoped=true"
import script from "./SearchContent.vue?vue&type=script&lang=js"
export * from "./SearchContent.vue?vue&type=script&lang=js"
import style0 from "./SearchContent.vue?vue&type=style&index=0&id=7b6b16a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6b16a4",
  null
  
)

export default component.exports